import { listLabel } from "./columnDefs";
import { toListKey } from "./filterFns";

/** Opções do filtro lista: valores das facetas (já com os outros filtros aplicados) + selecionados. */
export const buildListOptions = (facets, config, current) => {
    const counts = new Map();
    for (const [value, count] of facets?.entries?.() ?? []) {
        const key = toListKey(value);
        counts.set(key, (counts.get(key) ?? 0) + count);
    }
    for (const key of current ?? []) {
        if (!counts.has(key)) counts.set(key, 0);
    }
    return [...counts.entries()]
        .map(([key, count]) => ({ key, count, label: listLabel(config, key) }))
        .sort((a, b) => a.label.localeCompare(b.label, "pt-BR"));
};
